import { DEFAULT_SITE_CONFIG, SITE_SLUG } from "./defaultSiteConfig";
import { DEFAULT_STUDIO_SITE_CONFIG } from "./studioSiteConfig";

export const ORG_SLUG = "578-org";

export const PUBLIC_SITES = [
  { slug: "578-prod", label: "578 Productions", supportsStartHere: false },
  { slug: "578-studio", label: "578 Studio", supportsStartHere: true },
];

export function siteSupportsStartHere(slug) {
  return PUBLIC_SITES.some((site) => site.slug === slug && site.supportsStartHere);
}

export const DEFAULT_ORG_CONFIG = {
  stores: [
    { id: "578-studio-ls", name: "578 Studio (Lemon Squeezy)", kind: "digital", storeUrl: "" },
    { id: "578-prod-ls", name: "578 Productions (Lemon Squeezy)", kind: "digital", storeUrl: "" },
    { id: "578-other", name: "Other destinations", kind: "other", storeUrl: "" },
  ],
  formats: [
    { id: "guide", label: "Guide" },
    { id: "resource", label: "Resource" },
    { id: "framework", label: "Framework" },
    { id: "toolkit", label: "Toolkit" },
    { id: "template", label: "Template" },
    { id: "saas", label: "SaaS" },
    { id: "extension", label: "Extension" },
    { id: "game", label: "Game" },
    { id: "media", label: "Media" },
  ],
};

export function defaultConfigForSlug(slug) {
  if (slug === "578-studio") return DEFAULT_STUDIO_SITE_CONFIG;
  if (slug === ORG_SLUG) return DEFAULT_ORG_CONFIG;
  return DEFAULT_SITE_CONFIG;
}

export function publicSiteSlug(candidate, fallback = SITE_SLUG) {
  if (PUBLIC_SITES.some((site) => site.slug === candidate)) return candidate;
  return fallback;
}

// Only trust REACT_APP_STUDIO_ORIGIN when it is an https URL; anything else is
// treated as unset so we fall back to the same-origin preview path.
export function safeStudioOrigin(origin = "") {
  if (typeof origin !== "string" || !origin.startsWith("https://")) return "";
  return origin.replace(/\/$/, "");
}

// Draft previews are always same-origin: the admin session cookie does not
// travel to a cross-origin iframe (storage partitioning), so a cross-origin
// "draft preview" could never authenticate. Cross-origin draft preview ships
// with SNDR-163 (signed preview token).
export function draftPreviewHref(siteSlug) {
  const params = new URLSearchParams({ preview: "true" });
  if (siteSlug !== SITE_SLUG) params.set("site", siteSlug);
  return `/?${params.toString()}`;
}

// The published Studio site (not a draft). Empty string when no valid https
// Studio origin is configured.
export function publishedStudioHref(studioOrigin = "") {
  const origin = safeStudioOrigin(studioOrigin);
  return origin ? `${origin}/` : "";
}
